/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { Table, Panel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { routerActions } from 'react-router-redux';
import { format, addSeconds } from 'date-fns';
import { callAPI } from 'lorautils/api';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Refresher from 'loracoms/Refresher';
import ShowIf from 'loracoms/ShowIf';
import ParsedDataTrend from '../ParsedDataTrend';
import styles from './styles.scss';

const propTypes = {
  load: PropTypes.bool.isRequired,
  intl: PropTypes.any.isRequired,
  deveui: PropTypes.string.isRequired,
  markState: PropTypes.object.isRequired,
  // appId: PropTypes.string.isRequired,
};

class ParsedData extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      metrics: '',
      status: 'pending',
    };
    this.mark = props.markState.mark || {};
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parsers.data');
    this.handleReload = this.handleReload.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { markState, load } = nextProps;
    if (!_.isEqual(markState, this.props.markState)) {
      this.mark = markState.mark;
    }
    if (load) {
      this.loadData();
    }
  }

  loadData() {
    const { deveui } = this.props;
    this.setState({ status: 'pending' });
    let { from, to } = this.mark;
    if (_.isNil(from) || _.isNil(to)) {
      this.setState({ timeSeries: [], status: 'success' });
      return;
    }
    from = new Date(from);
    to = addSeconds(new Date(to), 5);
    callAPI({
      endpoint: '/lora/timeseries',
      body: {
        nodeid: deveui,
        limit: 20,
        dir: 'up',
        from,
        to,
      },
      method: 'POST',
    }).then((data) => {
      this.setState({
        timeSeries: data.list,
        status: 'success',
      });
    }).catch(() => {
      this.setState({
        status: 'failure',
      });
    });
  }

  handleReload() {
    this.loadData();
  }

  render() {
    const { timeSeries = [], status = 'pending', metrics } = this.state;

    const dataPoints = _.uniq(_.flatMap(timeSeries, ts => _.keys(ts.metrics)));
    const ths = dataPoints.map(dp => (
      <th key={dp}>
        {dp}
        <Link
          className={`fa fa-line-chart ${styles.graph}`}
          onClick={() => this.setState({ metrics: dp })}
        />
      </th>
    ));
    const trs = timeSeries.map((ts, idx) => (
      <tr key={String(idx)}>
        <td>{format(ts.timestamp, 'YYYY-MM-DD HH:mm:ss')}</td>
        {
          dataPoints.map((dp) => {
            const dpValue = ts.metrics[dp];
            if (dpValue) {
              const pointer = dpValue.indexOf('.');
              let val = dpValue;
              if (pointer > -1) {
                val = dpValue.substring(pointer + 1).length > 4 ?
                  Number(dpValue).toFixed(4) : dpValue;
              }
              return <td key={dp}>{val}</td>;
            }
            return <td key={dp}>{dpValue}</td>;
          })
        }
      </tr>
    ));
    const tooltip = <Tooltip id="tooltip">{this.intlMsg.msg('back')}</Tooltip>;
    const header = (
      <div>
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.handleReload}
              reloading={status === 'pending'}
            />
          </li>
          <ShowIf if={metrics.length !== 0}>
            <li>
              <OverlayTrigger placement="top" overlay={tooltip}>
                <Link
                  className={`glyphicons glyphicons-step-backward ${styles.gray}`}
                  onClick={() => this.setState({ metrics: '' })}
                />
              </OverlayTrigger>
            </li>
          </ShowIf>
        </ul>
      </div>
    );

    if (status === 'pending') {
      return (
        <div className={styles.load}>
          <i className="fa fa-spinner fa-spin fa-5x" />
        </div>
      );
    } else if (status === 'failure') {
      return (
        <div className={styles.timeout}>
          <i className="fa fa-info-circle" />&nbsp;
          {this.intlMsg.msg('failure')}
        </div>
      );
    } else if (timeSeries.length === 0 && status === 'success') {
      return (
        <Panel bsStyle="aisz-white" header={header}>
          <div className={styles.noData}>
            {this.intlMsg.msg('nodata01')}
            {/* <Link
              className={styles.blue}
              to={`/application/${this.props.appId}/parse`}
            >
              {this.intlMsg.msg('nodata02')}
            </Link> */}
          </div>
        </Panel>
      );
    }

    return (
      <Panel bsStyle="aisz-white" header={header} className="parsedDataMaxHeight">
        <ShowIf if={metrics.length === 0}>
          <Table className="aisz-table-light" striped bordered hover responsive>
            <thead>
              <tr>
                <th>
                  {this.intlMsg.msg('thead.time')}
                </th>
                {ths}
              </tr>
            </thead>
            <tbody>
              {trs}
            </tbody>
          </Table>
        </ShowIf>
        <ShowIf if={metrics.length !== 0}>
          <ParsedDataTrend list={timeSeries} metrics={metrics} dataPoints={dataPoints} />
        </ShowIf>
      </Panel>
    );
  }
}

ParsedData.propTypes = propTypes;

const mapStateToProps = state => ({
  markState: state.mark,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ParsedData));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DataToolView/coms/ParsedData/index.jsx